var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoonriverMovr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1130.7 874.7",
    style: {
      enableBackground: "new 0 0 1130.7 874.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000070110787717766277210000005938417369816824765_);fill:#F2B705;}\r\n\t.st1{clip-path:url(#SVGID_00000070110787717766277210000005938417369816824765_);fill:#53CBC8;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 190.3,
    y: 62.3,
    width: 750,
    height: 750
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143594202162686966510000014059526069895286686_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#F2B705"
    },
    d: "M560.3,75.4 c-149.5,0-270.6,121.2-270.7,270.7c0,17.1,1.6,34.2,4.8,51l35-23.9c61.5-42.2,161.2-42.2,222.6,0l36.7,25.2l19.9,13.7 c55.4,38,145.2,38,200.5,0l16.3-11.1c30-146.5-64.4-289.6-210.9-319.7c-17.8-3.7-35.9-5.5-54.1-5.5L560.3,75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M712.4,508.7 c-38.7,0.7-76.7-10.1-109.1-31l-56.5-38.7c-62.7-38.5-141.8-38.5-204.6,0l-36.5,25c-7.2,5-17.1,3.1-22.1-4.1 c-5-7.2-3.1-17.1,4.1-22.1l36.5-25c73.6-45.7,166.8-45.7,240.4,0l56.5,38.7c55.9,34.3,126.4,34.3,182.3,0l21.4-14.7 c7.2-5,17.1-3.1,22.1,4.1c5,7.2,3.1,17.1-4.1,22.1l-21.4,14.7C789,498.5,751,509.3,712.4,508.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M443.3,622.4V469.4 c-0.1-3.2,0-6.4,0.4-9.6c1-8.7,8.4-15.3,17.2-15.3c8.5,0.3,15.4,6.8,16.2,15.3c0.7,5.3,0.8,10.7,0.6,16v305 c0.4,9.9-7.3,18.1-17.2,18.5c-0.1,0-0.2,0-0.3,0c-9.7-0.5-17.1-8.8-16.6-18.5c0-0.3,0-0.6,0.1-0.8V678.2L443.3,622.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M411.2,545.4v76 c0,13-7.1,21.4-16.8,21.4c-9.6,0-17.3-9.1-17.4-21.4V469.3c0-13.3,7.8-22.3,17.9-21.4c10.1,0.9,16.1,8.5,16.2,21.9 C411.2,494.7,411.2,520,411.2,545.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M509.9,545.3v-53.3 c0-12.4,6.6-20.4,16.4-20.4c10.1,0.5,18,9.1,17.5,19.2c0,0.2,0,0.5,0,0.7c0.3,36.3,0.3,72.6,0,109c0,12.4-7.1,19.9-17.4,19.7 c-10.2-0.1-16.4-7.7-16.5-20.4L509.9,545.3L509.9,545.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M310.8,556.3v-53.4 c0-12.4,6.6-20.4,16.4-20.4c10.1,0.5,18,9.1,17.5,19.2c0,0.2,0,0.5,0,0.7c0.3,36.4,0.3,72.7,0,109.1c0,12.4-7.1,19.8-17.3,19.7 c-10.1-0.1-16.5-7.7-16.6-20.4L310.8,556.3L310.8,556.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M592.8,510.9 L592.8,510.9c9.3,0,16.8,7.5,16.8,16.8v29c0,9.3-7.5,16.8-16.8,16.8s-16.8-7.5-16.8-16.8v-29C576.1,518.5,583.6,510.9,592.8,510.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M659.3,536.4 L659.3,536.4c9.3,0,16.8,7.5,16.8,16.8v162.9c0,9.3-7.5,16.8-16.8,16.8s-16.8-7.5-16.8-16.8V553.2 C642.5,543.9,650,536.4,659.3,536.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M725.4,542.7 L725.4,542.7c9.3,0,16.8,7.5,16.8,16.8v138.4c0,9.3-7.5,16.8-16.8,16.8c-9.3,0-16.8-7.5-16.8-16.8V559.5 C708.6,550.2,716.1,542.7,725.4,542.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000143594202162686966510000014059526069895286686_)",
      fill: "#53CBC8"
    },
    d: "M792.3,526.9 L792.3,526.9c9.3,0,16.8,7.5,16.8,16.8v59.7c0,9.3-7.5,16.8-16.8,16.8c-9.3,0-16.8-7.5-16.8-16.8v-59.7 C775.5,534.4,783.1,526.9,792.3,526.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonriverMovr);
export default __webpack_public_path__ + "static/media/Moonriver-MOVR.97fa34c763e08c13b0e4b02c67b33f2e.svg";
export { ForwardRef as ReactComponent };